import { useState } from "react";
import WizardNav from "../../components/Wizard/WizardNav";
import { useTranslation } from "react-i18next";
import CreatePolicy from "../PrivateArea/Policies/Crud/CreatePolicy";
import PoliciesTable from "../PrivateArea/Policies/PoliciesTable";

export default function Policy({
  stepData,
  setStepData,
  next,
  back,
  canGoNext,
  isFirst,
  isLast,
}) {
  const { t } = useTranslation();

  const [createOpen, setCreateOpen] = useState(false);
  const handleCloseCreate = () => setCreateOpen(false);

  const selectedIds = stepData?.configById ?? stepData?.step2?.configById ?? [];

  const isSelectionValid = Array.isArray(selectedIds) && selectedIds.length > 0;
  const canProceed = Boolean(canGoNext && isSelectionValid);

  return (
    <section className="pb4">
      <div className="bgwhite mtb2">
        <div className="plr3 ptb">
          <PoliciesTable
            variant="embedded"
            showBreadcrumb={false}
            showHeader={true}
            stepData={stepData}
            setStepData={setStepData}
            stepKey="step2"
          />
        </div>
      </div>

      <div className="wz-footer">
        <WizardNav
          back={back}
          next={next}
          isFirst={isFirst}
          isLast={isLast}
          canGoNext={canProceed}
        />
      </div>

      <CreatePolicy open={createOpen} onClose={handleCloseCreate} t={t} />
    </section>
  );
}
